import { NavList } from './NavList'
import { useAppState } from '../../state/store'

/** Barra lateral responsiva: colapsable en escritorio, deslizable en móvil. */
export function Sidebar() {
  const { state, dispatch } = useAppState()

  return (
    <>
      <aside
        className={state.sidebarOpen ? 'sidebar sidebar--open' : 'sidebar sidebar--closed'}
        aria-hidden={!state.sidebarOpen}
      >
        <div className="sidebar__brand">
          <span className="sidebar__logo" aria-hidden="true">
            ▲
          </span>
          <span className="sidebar__brand-text">AGOS</span>
        </div>
        <NavList />
        <div className="sidebar__footer">
          <span className="sidebar__version">Consola interna · v0.1</span>
        </div>
      </aside>
      {state.sidebarOpen && (
        <button
          type="button"
          className="sidebar__scrim"
          aria-label="Cerrar menú"
          onClick={() => dispatch({ type: 'SET_SIDEBAR', open: false })}
        />
      )}
    </>
  )
}
